import { ORG_NAME_MAX_LENGTH } from '@kaiizen/kai-pro-api';

import { CommonField } from '@kaiizen/kai-shiki/react';

import { DEFAULT_SUPER_ADMIN_TOOLS_PANEL_STYLES, SuperAdminToolsPanelStyles } from './superAdminToolsPanelStyles';

/** An org's name, as both Create Org and Current Org edit it. */
export const SuperAdminOrgNameField = ({ name, onChange }: { name: string; onChange: (name: string) => void }) => (
  <CommonField
    label='Org name'
    helperText={`1 to ${ORG_NAME_MAX_LENGTH} characters`}
    inputProps={{ value: name, placeholder: 'Acme Rentals', onChange: event => onChange(event.target.value) }}
  />
);

/** An org's Live flag, as both Create Org and Current Org edit it. */
export const SuperAdminOrgLiveCheckbox = ({
  isLive,
  onChange,
  styles = DEFAULT_SUPER_ADMIN_TOOLS_PANEL_STYLES,
}: {
  isLive: boolean;
  onChange: (isLive: boolean) => void;
  styles?: SuperAdminToolsPanelStyles;
}) => (
  <label css={styles.actions}>
    <input type='checkbox' checked={isLive} onChange={event => onChange(event.target.checked)} />
    {'Live: include this org in billing and cost reports'}
  </label>
);
